// Vendor libraries
import { createReducer, on } from '@ngrx/store';
// Enums
import { ScatterPlotPlotType } from 'ChartApp/ts/enums/scatter-plot-common.enum';
// Action imports
import { setScatterPlot } from 'ChartApp/ts/apps/scatter-plot/state/scatter-plot.actions';
import { setXAxisDate } from './x-axis-date.actions';
export const xAxisDate = createReducer(null, on(setScatterPlot, (state, action) => {
    if (action.scatterPlot.plotType === ScatterPlotPlotType.pointInTime) {
        return action.scatterPlot.xAxisDate;
    }
    return state;
}), on(setXAxisDate, (state, { date }) => {
    return date;
}));
